/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NoveltyCalcLaunchStatusFilter = {
    All: 'All',
    FirstHalf: 'FirstHalf',
    SecondHalf: 'SecondHalf'
} as const;
export type NoveltyCalcLaunchStatusFilter = typeof NoveltyCalcLaunchStatusFilter[keyof typeof NoveltyCalcLaunchStatusFilter];


export function instanceOfNoveltyCalcLaunchStatusFilter(value: any): boolean {
    for (const key in NoveltyCalcLaunchStatusFilter) {
        if (Object.prototype.hasOwnProperty.call(NoveltyCalcLaunchStatusFilter, key)) {
            if (NoveltyCalcLaunchStatusFilter[key as keyof typeof NoveltyCalcLaunchStatusFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NoveltyCalcLaunchStatusFilterFromJSON(json: any): NoveltyCalcLaunchStatusFilter {
    return NoveltyCalcLaunchStatusFilterFromJSONTyped(json, false);
}

export function NoveltyCalcLaunchStatusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcLaunchStatusFilter {
    return json as NoveltyCalcLaunchStatusFilter;
}

export function NoveltyCalcLaunchStatusFilterToJSON(value?: NoveltyCalcLaunchStatusFilter | null): any {
    return value as any;
}

export function NoveltyCalcLaunchStatusFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): NoveltyCalcLaunchStatusFilter {
    return value as NoveltyCalcLaunchStatusFilter;
}

